import { AxiosRequestConfig, AxiosResponse } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import type {
  AdminCreateIntegrationRequest,
  AdminCreateIntegrationResponse,
  AdminListIntegrationsResponse,
  AdminShowIntegrationResponse,
  AdminUpdateIntegrationRequest,
  AdminUpdateIntegrationResponse,
} from "./types";

// Export types
export * from "./types";

const ENDPOINTS = {
  // Admin Integration Management
  ADMIN_INTEGRATIONS: "/api/v1/admin/integrations",
  ADMIN_INTEGRATION: "/api/v1/admin/integrations/:integration_id",
  ADMIN_INTEGRATIONS_SYNC: "/api/v1/admin/integrations-sync",

  // Integration Proxy
  INTEGRATION_PROXY:
    "/api/v1/org/:organization_id/integrations/:integration_id/proxy/:path",
};

export class IntegrationsAPI {
  private client: CohesiveAPIClient;

  constructor(client: CohesiveAPIClient) {
    this.client = client;
  }

  // Admin Integration Management
  async adminList(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<AdminListIntegrationsResponse>> {
    return this.client.axios.get<AdminListIntegrationsResponse>(
      ENDPOINTS.ADMIN_INTEGRATIONS,
      config,
    );
  }

  async adminShow(
    integrationId: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<AdminShowIntegrationResponse>> {
    return this.client.axios.get<AdminShowIntegrationResponse>(
      route(ENDPOINTS.ADMIN_INTEGRATION, { integration_id: integrationId }),
      config,
    );
  }

  async adminCreate(
    data: AdminCreateIntegrationRequest,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<AdminCreateIntegrationResponse>> {
    return this.client.axios.post<AdminCreateIntegrationResponse>(
      ENDPOINTS.ADMIN_INTEGRATIONS,
      data,
      config,
    );
  }

  async adminUpdate(
    integrationId: string,
    data: AdminUpdateIntegrationRequest,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<AdminUpdateIntegrationResponse>> {
    return this.client.axios.put<AdminUpdateIntegrationResponse>(
      route(ENDPOINTS.ADMIN_INTEGRATION, { integration_id: integrationId }),
      data,
      config,
    );
  }

  async adminSync(config?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
    return this.client.axios.post(
      ENDPOINTS.ADMIN_INTEGRATIONS_SYNC,
      {},
      config,
    );
  }
}
